import ApiService from "@/api/apiService";
import {CustomSelectItem} from "@/components/CustomSelect.vue";

export default class IndicatorService {
  public static cache: CustomSelectItem[] = [];

  public static async getCurrentList(): Promise<CustomSelectItem[]> {

    if (this.cache.length === 0) {
      try {
        const indicatorList = await ApiService.getIndicatorList();
        const tempList: CustomSelectItem[] = [];
        for (const indicator of indicatorList.list) {
          tempList.push({
            value: indicator.value,
            label: indicator.label,
            default: indicator.default ? indicator.default : false
          });
        }
        this.cache = tempList;
      } catch (error) {
        return Promise.reject();
      }
    }

    return Promise.resolve(this.cache);
  }
}